import { gql, TypedDocumentNode } from "@apollo/client";

import { AzureIntegration } from "types/generated";

export type AzureIntegrationView = Pick<
  AzureIntegration,
  | "__typename"
  | "adminConsentProvided"
  | "adminConsentURL"
  | "applicationId"
  | "displayName"
  | "id"
  | "labels"
  | "name"
  | "tenantId"
  | "servicePrincipalObjectId"
  | "defaultSubscriptionId"
  | "autoattachEnabled"
  | "hasAttachedStacks"
> & {
  spaceDetails: Pick<AzureIntegration["spaceDetails"], "id" | "name" | "accessLevel">;
};

type SearchAzureIntegrationsData = {
  azureIntegrations: AzureIntegrationView[];
};

export const SEARCH_AZURE_INTEGRATIONS: TypedDocumentNode<SearchAzureIntegrationsData> = gql`
  query SearchAzureIntegrations {
    azureIntegrations {
      __typename
      adminConsentProvided
      adminConsentURL
      applicationId
      displayName
      id
      labels
      name
      tenantId
      servicePrincipalObjectId
      defaultSubscriptionId
      autoattachEnabled
      spaceDetails {
        id
        name
        accessLevel
      }
      hasAttachedStacks
    }
  }
`;
